<div class="modal fade" id="modalWarehouse" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalToggleLabel">DANH SÁCH KHO HÀNG</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="col-sm-12 d-flex justify-content-between flex-wrap mb-5">
                    <div class="col-sm-9 d-flex flex-column gap-3">
                        <div class="col-sm-12 d-flex gap-5 flex-wrap justify-content-between">
                            <div class="col-sm-4">
                                <InputTextNormal
                                        :label="dataSearch.warehouse_name.label"
                                        :id="dataSearch.warehouse_name.id"
                                        :placeholder="dataSearch.warehouse_name.placeholder"
                                        :value-default="dataSearch.warehouse_name.value"
                                        @inputValue="onChange($event, dataSearch.warehouse_name.id)"
                                        :required="dataSearch.warehouse_name.required"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-4">
                                <InputTextNormal
                                        :label="dataSearch.warehouse_code.label"
                                        :id="dataSearch.warehouse_code.id"
                                        :placeholder="dataSearch.warehouse_code.placeholder"
                                        :value-default="dataSearch.warehouse_code.value"
                                        @inputValue="onChange($event, dataSearch.warehouse_code.id)"
                                        :required="dataSearch.warehouse_code.required"
                                ></InputTextNormal>
                            </div>
                        </div>
                        <div class="col-sm-12 d-flex gap-5 flex-wrap justify-content-between">
                            <div class="col-sm-4">
                                <InputTextNormal
                                        :label="dataSearch.warehouse_phone.label"
                                        :id="dataSearch.warehouse_phone.id"
                                        :placeholder="dataSearch.warehouse_phone.placeholder"
                                        :value-default="dataSearch.warehouse_phone.value"
                                        @inputValue="onChange($event, dataSearch.warehouse_phone.id)"
                                        :required="dataSearch.warehouse_phone.required"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-4">
                                <InputTextNormal
                                        :label="dataSearch.warehouse_addr.label"
                                        :id="dataSearch.warehouse_addr.id"
                                        :placeholder="dataSearch.warehouse_addr.placeholder"
                                        :value-default="dataSearch.warehouse_addr.value"
                                        @inputValue="onChange($event, dataSearch.warehouse_addr.id)"
                                        :required="dataSearch.warehouse_addr.required"
                                ></InputTextNormal>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-1 d-flex flex-column justify-content-end">
                        <ButtonSearchComponent :label="labelButtonSearch" @click="searchWarehouses"></ButtonSearchComponent>
                    </div>
                </div>
                <table class="table">
                    <thead>
                    <tr>
                        <th style="width: 2%;" class="text-center">
                        </th>
                        <th class="text-center" scope="col" v-for="header in dataHeaderTable" :key="header.order" :style="{ 'width': header.width }">{{header.label}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="listsWarehouseCurrent.length > 0" v-for="warehouse in listsWarehouseCurrent" :key="warehouse.id">
                        <td class="text-center"><InputCheckboxOne :id="'select_' + warehouse.id" :value-default="listChecked[warehouse.id]" @inputValue="onChangeSelectWarehouse($event, warehouse.id)" :checked="listChecked[warehouse.id]"></InputCheckboxOne></td>
                        <td>{{ warehouse.name}}</td>
                        <td>{{ warehouse.code }}</td>
                        <td>{{ warehouse.phone }}</td>
                        <td>{{ warehouse.productCount }}</td>
                        <td>{{ warehouse.totalQuantity }}</td>
                        <td>{{ warehouse.address }}</td>
                    </tr>
                    <tr v-else>
                        <td colspan="8" class="text-center">Không có kho hàng nào được tìm thấy</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <PaginateComponent v-if="paginate.pageCount > 1" :paginate="paginate" :urlOrigin="urlOrigin" @page="emitPage($event)"></PaginateComponent>
            <div class="modal-footer d-flex justify-content-center">
                <button class="btn btn-primary" @click="applyWarehouseSelected">Áp dụng</button>
            </div>
        </div>
    </div>
</div>
